import { splitLookupCodeAndDescription } from "../core/ewcDefaultRuleDisplay";
import "./EwcRuleLookupDisplay.css";

export function EwcRuleLookupDisplay({
    display,
    formatCode,
}: {
    display: string;
    formatCode?: (code: string) => string;
}) {
    const { code, description } = splitLookupCodeAndDescription(display);
    const formattedCode = formatCode ? formatCode(code) : code;

    if (!description) {
        return <>{formattedCode}</>;
    }

    return (
        <>
            {formattedCode}
            <span className="ewc-rule-lookup-description"> — {description}</span>
        </>
    );
}
